import React from 'react';
import Button from '$/components/base/Button';
import type { OverseaFeatureItem } from '@/apiSdk/api.type';
import classNames from 'classnames';
import styles from './index.module.scss';

interface SwitchCategoryProps {
  productMenus: OverseaFeatureItem[];
  activeCategory: number;
  handleCategoryClick: (id: number) => void;
}

export default function SwitchCategory({ productMenus, activeCategory, handleCategoryClick }: SwitchCategoryProps) {
  const categories = (productMenus || []).filter((item) => item.category_id !== 0);

  return (
    <div className={styles['switch-category']}>
      <div className={styles['switch-category-list']}>
        {categories.map((category) => (
          <Button
            key={category.category_id}
            onClick={() => handleCategoryClick(category.category_id)}
            className={classNames(styles['switch-category-button'], { [styles.active]: activeCategory === category.category_id })}
          >
            {category.category}
          </Button>
        ))}
      </div>
    </div>
  );
}
